<template>
  <div class="wrap">
    <component
      :is="showComponent(item)"
      v-for="item in categoryList"
      :key="item.id"
      :item="item"
      :allBenefitList="benefitList"
      v-show="isShow(item)"
      :packageInfo="packageInfo"
    />
  </div>
</template>

<script>
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  watch,
} from "@vue/composition-api";
import Vue from "vue";
import qs from "qs";

import {
  getIndexCategory,
  getIndexClassList,
  getPackageList,
} from "@/apis/product";
import { useStore, useRouter, useRoute } from "@/components/use/base";
import { getNamespaceBenefit } from "@/apis/home";
import { jsonSafeParse } from "@/utils";

import HbHeader from "../component/common/HbHeader.vue";
import HbBenefit from "../component/common/HbBenefit.vue";
import Header from "../../member/component/header.vue";

const vm = Vue.prototype;

export default defineComponent({
  components: {
    HbHeader,
    HbBenefit,
    Header,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    const categoryList = ref([]);
    const benefitList = ref([]);
    const packageInfo = ref({});

    const isMember = computed(() => store.state.isMember);
    const packageName = computed(() => store.state.namespaceInfo.package);
    const namespace = computed(() => store.state.namespace);
    const namespaceGroup = computed(
      () => store.state.namespaceInfo?.namespace_group_en
    );

    const isShow = computed(() => (item) => {
      if (item.display_code === "HbHeader") return true;
      let show = false;
      const productInfo = item.productInfo;
      productInfo.forEach((element) => {
        if (benefitList.value.includes(element.benefit_type)) show = true;
      });
      return show;
    });

    watch(
      isMember,
      (newVal) => {
        if (newVal && !["58sk"].includes(namespaceGroup.value)) {
          const params = qs.stringify(route.query);
          if (newVal) {
            router.replace(`/index?${params}`);
          }
        }
      },
      { immediate: true }
    );

    const showComponent = computed(() => (item) => {
      if (item.display_code === "HbHeader") return "HbHeader";
      if (item.display_code === "Header") return "Header";
      return "HbBenefit";
    });

    const initDataPage = async () => {
      const packageMap = jsonSafeParse(vm.$getConfigValue("BJ_CARD_MAP"));
      const page = packageMap[namespace.value].page;
      const { data: categoriesData } = await getIndexCategory({
        namespace: page,
        opened_page: "member",
        source: "default",
      });
      const { data: productData } = await getIndexClassList({
        title: categoriesData.map((v) => v.name).join(","),
        opened_page: "member",
        namespace: page,
      });
      categoryList.value = categoriesData
        .map((value) => ({
          ...value,
          productInfo: productData[value.name] || [],
        }))
        .filter((item) => item.display_code !== "onlineOrdering");

      const { data } = await getNamespaceBenefit({
        package: packageName.value.split(",")[0],
        namespace: namespace.value,
      });
      benefitList.value = data.map((item) => item.benefit_type);
    };

    const fetchPackage = async () => {
      const { data } = await getPackageList({
        namespace: namespace.value,
        source: "default",
      });
      packageInfo.value = data[0];
    };

    onMounted(() => {
      initDataPage();
      fetchPackage();
    });

    return {
      showComponent,
      categoryList,
      benefitList,
      isShow,
      packageInfo,
    };
  },
});
</script>

<style lang="less" scoped>
.wrap {
  background-color: #fff;
  padding-bottom: 70px;
}
</style>
